// Use environment variable, with fallback to localhost for dev
import axios from 'axios';

// Ensure API URL has protocol (https:// or http://)
let apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
if (apiUrl && !apiUrl.match(/^https?:\/\//)) {
  // Add https:// if protocol is missing
  apiUrl = `https://${apiUrl}`;
}

const api = axios.create({
  baseURL: apiUrl,
});

// Add auth token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
